<template>
  <router-view></router-view>
</template>
<style lang="less" type="text/less"></style>
<script>
export default {
  name: 'EmptyView'
}
</script>
